import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient} from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient) {
    this.loadConfig();
    this.loadConfigSalud();
  }

  async loadConfig(): Promise<void> {
    const configData = await lastValueFrom(
      this.http.get<any>(environment.configFile)
    );
    
    for (const key in configData) {
      environment[key] = configData[key];
    }
    
  }

  async loadConfigSalud(): Promise<void> {
    const configSaludData = await lastValueFrom(
      this.http.get<any>(environment.configSaludFile)
    );

    for (const key in configSaludData) {
      environment[environment.configSaludSeccion][key] = configSaludData[key];
    }
  }

}